module.exports = {"330326100":"昆阳镇","330326101":"鳌江镇","330326102":"水头镇","330326103":"萧江镇","330326105":"腾蛟镇","330326107":"山门镇","330326108":"顺溪镇","330326109":"南雁镇","330326117":"万全镇","330326118":"海西镇","330326119":"南麂镇","330326120":"麻步镇","330326121":"凤卧镇","330326122":"怀溪镇","330326214":"青街畲族乡","330326217":"闹村乡","330326401":"滨海新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330326.json
// module id = 972
// module chunks = 0